import collect from "./collect";

export default (kind, sections) => {
  let findedNodes = [];

  collect(sections, (type, node) => {
    if (node.kind === kind) {
      findedNodes.push(node);
    }
    return false;
  });

  return findedNodes;
};
